import * as api from '@/api'

export default {
  async liqpayCheckout(payload) {
    let result = {}

    try {
      result = await api.payments.liqpayCheckout(payload)
    } catch (error) {
      console.error(error)
    }

    return result
  },

  async liqpayCheckPaymentStatus(orderId) {
    let result = {}

    try {
      result = await api.payments.liqpayCheckPaymentStatus(orderId)
    } catch (error) {
      console.error(error)
    }

    return result
  }
}
